import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ConfigMutationModals from '../../components/SetupSubPageComps/ConfigurationsComps/ConfigMutationModals';
import ShowAllConfigs from '../../components/SetupSubPageComps/ConfigurationsComps/ShowAllConfigs';
import ConfigProvider from '../../contexts/ConfigProvider';
import MutationModalProvider from '../../contexts/MutationModalProvider';

const Configurations = () => {
  // rendering configurations page component here
  return (
    <>
      <PageTitle title='Configurations' />

      <MutationModalProvider>
        <ConfigProvider>
          <ShowAllConfigs />
          <ConfigMutationModals />
        </ConfigProvider>
      </MutationModalProvider>
    </>
  );
};

export default Configurations;
